import { FeedbackForm } from '#app/components/feedback/feedback-form.tsx'
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '#app/components/ui/card.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { type SeoProps } from '#app/seo/seo.tsx'

export const handle = {
	seo({ canonical }: { canonical: string }): SeoProps {
		return {
			title: 'Contact Us - RentDFW.com',
			description:
				"Get in touch with the RentDFW team. We're here to help with any questions or feedback you may have.",
			canonical,
		}
	},
}

export default function ContactPage() {
	return (
		<>
			{/* SEO is handled by SeoHead via handle.seo */}

			<div className="container mx-auto max-w-2xl px-4 py-16">
				<div className="mb-8 text-center">
					<h1 className="mb-4 text-4xl font-bold">Contact Us</h1>
					<p className="text-muted-foreground text-lg">
						Have a question or feedback? We'd love to hear from you.
					</p>
				</div>

				<Card>
					<CardHeader>
						<CardTitle>Send us a message</CardTitle>
						<CardDescription>
							Fill out the form below and we'll get back to you as soon as
							possible.
						</CardDescription>
					</CardHeader>
					<CardContent>
						<FeedbackForm
							variant="contact"
							defaultValues={{
								pageUrl: '/contact',
							}}
						/>
					</CardContent>
				</Card>

				<div className="mt-12 grid gap-6 md:grid-cols-3">
					<div className="text-center">
						<div className="bg-primary/10 mx-auto mb-4 flex size-12 items-center justify-center rounded-full">
							<Icon name="envelope-closed" className="text-primary size-6" />
						</div>
						<h3 className="mb-2 font-semibold">Email</h3>
						<p className="text-muted-foreground text-sm">
							We'll respond within 24 hours
						</p>
					</div>

					<div className="text-center">
						<div className="bg-primary/10 mx-auto mb-4 flex size-12 items-center justify-center rounded-full">
							<Icon name="flag" className="text-primary size-6" />
						</div>
						<h3 className="mb-2 font-semibold">Feedback</h3>
						<p className="text-muted-foreground text-sm">
							Help us improve our platform
						</p>
					</div>

					<div className="text-center">
						<div className="bg-primary/10 mx-auto mb-4 flex size-12 items-center justify-center rounded-full">
							<Icon
								name="question-mark-circled"
								className="text-primary size-6"
							/>
						</div>
						<h3 className="mb-2 font-semibold">Support</h3>
						<p className="text-muted-foreground text-sm">
							Get help with your account
						</p>
					</div>
				</div>
			</div>
		</>
	)
}
